export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/patterntap/svg-9b23f071dd1616622b4eeaa9f43ebeb8.png";